export default __webpack_public_path__ + "static/media/gaj.9c5d766d.png";